import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/saif-dc/DC/projects/react-node-js/ucb/components/service/AllServicesDetails.jsx");
